import m, {Vnode} from "mithril";
import h from "../../ui/design";
import ProgressBar from "./ProgressBar";
import {Questionary} from "../../model/questionary";

export default class Header {

    public hint: string|null = null;
    public question: string|null = null;
    private progressBar: ProgressBar;

    constructor(
        private readonly questionary: Questionary,
    ) {
        this.progressBar = new ProgressBar(questionary);
    }

    public view(): Vnode {
        const form = this.questionary.currentForm;
        const formNumber = form?.getNumber() ?? '';
        const formText = form?.text || '';
        const question = this.question || formText;
        const formHint = form?.hint || '';
        const hint = this.hint || formHint;

        return m(".header", {}, [
            m(this.getQuestionClass(), {}, [
                m("p.question-number", {}, formNumber+'.'),
                m("p.question-text", {}, m.trust(this.questionary.renderText(question))),
            ]),
            m(this.progressBar),
            hint ? m('.hint', {},
                m('p', {}, m.trust(this.questionary.renderText(hint)))
            ) : null
        ]);
    }


    private getQuestionClass(): string {
        return window.innerWidth < h.BC.md ? '.question.has-primary-background' : '.question';
    }

    oncreate(): void {
        $(window).on('resize', () => m.redraw());
    }
}
